import { staticAsset, resolveCmsIconUrl } from './staticAssets.js';
import {
  filterCasinoGamesByTab,
  sortCasinoGames,
} from './casinoCategories.js';
import { selectionIconPath } from './casinoIcons.js';
import { categoryIcons } from './casinoCategoryIcons.js';
import { withAssetCacheVersion } from '../utils/assetCache';

const img = staticAsset;

const GR8_SVG_TABS = new Set([
  'tab-all', 'tab-favourites', 'tab-top', 'tab-new', 'tab-buy-bonus', 'tab-exclusive',
  'tab-jackpot', 'tab-crash', 'tab-free-spins', 'tab-books', 'tab-table-games',
  'tab-bingo', 'tab-roulette', 'tab-blackjack', 'tab-baccarat', 'tab-game-shows',
  'tab-vip-tables', 'tab-sic-bo', 'tab-big-x', 'tab-high-rtp',
]);


function preferGr8Svg(url) {
  if (!url || typeof url !== 'string') return url;
  const m = url.match(/\/categories\/gr8\/(tab-[a-z0-9-]+)\.(png|webp)/i);
  if (!m) return url;
  if (!GR8_SVG_TABS.has(m[1].toLowerCase())) return url;
  return url.replace(/\.(png|webp)(\?|$)/i, '.svg$2');
}

const gr8 = (name) => {
  const ext = GR8_SVG_TABS.has(name) ? 'svg' : 'png';
  const src = img(`/content/Casino/categories/gr8/${name}.${ext}`);
  return { icon: src, iconActive: src };
};

export const CASINO_LOBBIES = [
  { id: 'slots', label: 'Slots', lobbyId: null, ...categoryIcons('slots') },
  { id: 'live', label: 'Live-casino', lobbyId: 198, ...categoryIcons('live') },
  { id: 'poker', label: 'Poker', lobbyId: 312, ...categoryIcons('poker') },
  { id: 'tv', label: 'TV-games', lobbyId: 48, ...categoryIcons('tv') },
  { id: 'fast', label: 'Fast games', lobbyId: 284, ...categoryIcons('fast') },
  { id: 'virtual', label: 'Virtual sports', lobbyId: 293, ...categoryIcons('virtual') },
];



const fonbet = (dark, selected = dark) => {
  const selectedName = selected.endsWith('_selected.svg')
    ? selected
    : selected.replace(/\.svg$/i, '_selected.svg');
  // Paths already under /static/content — do not double-prefix via /content/...
  return {
    icon: img(`/content/Casino/categories/Dark/${dark}`),
    iconActive: img(`/content/Casino/categories/DarkSelected/${selectedName}`),
  };
};

export const CASINO_PAGE_TABS = [
  { id: 'review', routeId: '-1', label: 'Review', ...categoryIcons('review') },
  { id: 'favourites', routeId: '-3', label: 'Favoriler', ...categoryIcons('favourites') },
  { id: 'lastplayed', routeId: 'lastplayed', label: 'Son oynananlar', ...categoryIcons('lastplayed') },
  { id: 'top', routeId: '57', label: 'En iyi oyunlar', ...categoryIcons('top') },
  { id: 'all', routeId: '496', label: 'Tüm oyunlar', ...categoryIcons('all') },
  { id: 'tournaments', routeId: '431', label: 'Tournaments', ...categoryIcons('tournaments') },
  { id: 'jackpot-cards', routeId: '1089', label: 'Jackpot Cards', ...categoryIcons('jackpot-cards') },
  { id: 'new', routeId: '447', label: 'NEW', ...categoryIcons('new') },
  { id: 'world-cup', routeId: '1112', label: 'World Cup 2026', ...categoryIcons('world-cup') },
  { id: 'buy-bonus', routeId: '75', label: 'Buy Bonus', ...categoryIcons('buy-bonus') },
  { id: 'free-spins', routeId: '488', label: 'With free spins', ...categoryIcons('free-spins') },
  { id: 'exclusive', routeId: '494', label: 'Exclusive', ...categoryIcons('exclusive') },
  { id: 'jackpot', routeId: '500', label: 'Jackpot', ...categoryIcons('jackpot') },
  { id: 'cascade', routeId: '495', label: 'Cascade', ...categoryIcons('cascade') },
  { id: 'megaways', routeId: '499', label: 'Megaways', ...categoryIcons('megaways') },
  { id: 'collect', routeId: '503', label: 'Collect', ...categoryIcons('collect') },
  { id: 'wild', routeId: '505', label: 'Wild', ...categoryIcons('wild') },
  { id: 'double', routeId: '504', label: 'Double chance', ...categoryIcons('double') },
  { id: 'megax', routeId: '506', label: 'Mega X', ...categoryIcons('megax') },
  { id: 'respin', routeId: '507', label: 'Respin', ...categoryIcons('respin') },
  { id: 'retro', routeId: '56', label: 'Retro', ...categoryIcons('retro') },
  { id: 'fruits', routeId: '51', label: 'Fruits', ...categoryIcons('fruits') },
  { id: 'books', routeId: '212', label: 'Books', ...categoryIcons('books') },
  { id: 'vip-egt', routeId: 'vip-egt', label: 'Bell Link', ...categoryIcons('vip-egt') },
  { id: 'amusnet', routeId: 'amusnet', label: 'Amusnet', ...categoryIcons('amusnet') },
  { id: 'pragmatic-play', routeId: 'pragmatic-play', label: 'Pragmatic Play', ...categoryIcons('pragmatic-play') },
  { id: 'coins-link-vip', routeId: 'coins-link-vip', label: 'Coins Link VIP', ...categoryIcons('coins-link-vip') },
  { id: 'fast-football', routeId: 'fast-football', label: 'Fast Football', ...categoryIcons('fast-football') },
  { id: 'holdem', routeId: 'holdem', label: "Hold'em", ...categoryIcons('holdem') },
  { id: 'caribbean', routeId: 'caribbean', label: 'Caribbean', ...categoryIcons('caribbean') },
  { id: 'video-poker', routeId: 'video-poker', label: 'Video Poker', ...categoryIcons('video-poker') },
  { id: 'crash', routeId: 'crash', label: 'Crash games', ...categoryIcons('crash') },
  { id: 'table-games', routeId: 'table-games', label: 'Table games', ...categoryIcons('table-games') },
  { id: 'roulette', routeId: 'roulette', label: 'Rulet', ...categoryIcons('roulette') },
  { id: 'blackjack', routeId: 'blackjack', label: 'Blackjack', ...categoryIcons('blackjack') },
  { id: 'baccarat', routeId: 'baccarat', label: 'Baccarat', ...categoryIcons('baccarat') },
  { id: 'poker-live', routeId: 'poker-live', label: 'Poker', ...categoryIcons('poker-live') },
  { id: 'sic-bo', routeId: 'sic-bo', label: 'Sic Bo', ...categoryIcons('sic-bo') },
  { id: 'game-shows', routeId: 'game-shows', label: 'Oyun Şovları', ...categoryIcons('game-shows') },
  { id: 'vip-tables', routeId: 'vip-tables', label: 'VIP masalar', ...categoryIcons('vip-tables') },
  { id: 'mines', routeId: 'mines', label: 'Mines', ...categoryIcons('mines') },
  { id: 'plinko', routeId: 'plinko', label: 'Plinko', ...categoryIcons('plinko') },
  { id: 'dice', routeId: 'dice', label: 'Dice', ...categoryIcons('dice') },
  { id: 'scratch', routeId: 'scratch', label: 'Scratch games', ...categoryIcons('scratch') },
  { id: 'other', routeId: 'other', label: 'Other', ...categoryIcons('other') },
  { id: 'football', routeId: 'football', label: 'Football', ...categoryIcons('football') },
  { id: 'horse-racing', routeId: 'horse-racing', label: 'Horse Racing', ...categoryIcons('horse-racing') },
];


export const CASINO_SLIDES = [
  {
    title: "Cat's Blessing",
    sub: 'Discover a world of talismans',
    cta: 'Play',
    img: img('/content/Promo/tr/Slider_casino/2026/7.July/1.week/desktope-666.jpg'),
    bg: '#310077',
  },
  {
    title: '300 000 TL + 15 000 FS',
    sub: 'In the Legendary Race tournament',
    cta: 'Participate',
    img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/10.tour_Legendary_Race_060726/1377h450.jpg'),
    bg: '#060405',
    promoId: 'TR_Tournament_Legendary_Race',
  },
  {
    title: 'PETER & SONS Hits',
    sub: 'More than you could ever want',
    cta: 'Play',
    img: img('/content/Promo/tr/Slider_casino/2026/7.July/PETER_SONS_hits/1/1377h450.jpg'),
    bg: '#000000',
  },
  {
    title: 'Slattors Battle - Orcs vs Elves',
    sub: 'The war of ancient clans',
    cta: 'Play',
    img: img('/content/Promo/tr/Slider_casino/2026/7.July/1.week/desktope.jpg'),
    bg: '#2fa9bf',
  },
  {
    title: 'Donny Dough',
    sub: "Donny's money show",
    cta: 'Play',
    img: img('/content/Promo/tr/Slider_casino/2026/7.July/1.week/desktope-997.jpg'),
    bg: '#561070',
  },
  {
    title: 'Cakeshop Cascade',
    sub: 'Treat yourself to something sweet',
    cta: 'Play',
    img: img('/content/Promo/tr/Slider_casino/2026/7.July/1.week/desktope-322.jpg'),
    bg: '#8f75ff',
  },
  {
    title: 'Airavat - White Elephant',
    sub: 'Feel the spirit of legends',
    cta: 'Play',
    img: img('/content/Promo/tr/Slider_casino/2026/7.July/1.week/desktope-258.jpg'),
    bg: '#141bab',
  },
];

export function casinoTabByRouteId(routeId) {
  return CASINO_PAGE_TABS.find((t) => t.routeId === String(routeId)) || CASINO_PAGE_TABS[0];
}

export function casinoLobbyById(lobbyId) {
  if (lobbyId == null) return CASINO_LOBBIES[0];
  return CASINO_LOBBIES.find((l) => l.lobbyId === Number(lobbyId)) || CASINO_LOBBIES[0];
}

export function casinoLobbyLabelForRow(title) {
  const map = {
    Slots: 'slots',
    'Live-casino': 'live',
    Poker: 'poker',
    'TV-games': 'tv',
    'Fast games': 'fast',
    'Virtual sports': 'virtual',
  };
  return map[title] || 'slots';
}

export function filterCasinoGames(games, tabId) {
  return filterCasinoGamesByTab(games, tabId);
}

export { sortCasinoGames };

export const CASINO_PROVIDER_BADGES = {};

export const CASINO_PROVIDER_LIST = [];

export const CASINO_FILTER_SECTIONS = [
  {
    id: 'functions',
    labelKey: 'casino.filter.section.functions',
    items: [
      { id: 'bonus-game', labelKey: 'casino.filter.bonusGame', iconSection: 'Functions', iconFile: 'Bonusgame' },
      { id: 'buy-feature', labelKey: 'casino.filter.buyFeature', iconSection: 'Functions', iconFile: 'BuyFeature' },
      { id: 'expanding-symbols', labelKey: 'casino.filter.expandingSymbols', iconSection: 'Functions', iconFile: 'ExpandingSymbols' },
      { id: 'free-spins', labelKey: 'casino.filter.freeSpins', iconSection: 'Functions', iconFile: 'FreeSpins' },
      { id: 'multiplier', labelKey: 'casino.filter.multiplier', iconSection: 'Functions', iconFile: 'Multiplier' },
      { id: 'respins', labelKey: 'casino.filter.respins', iconSection: 'Functions', iconFile: 'Respins' },
      { id: 'symbols-collection', labelKey: 'casino.filter.symbolsCollection', iconSection: 'Functions', iconFile: 'SymbolsCollection' },
    ],
  },
  {
    id: 'themes',
    labelKey: 'casino.filter.section.themes',
    items: [
      { id: 'animals', labelKey: 'casino.filter.animals', iconSection: 'Themes', iconFile: 'animals' },
      { id: 'books', labelKey: 'casino.filter.books', iconSection: 'Themes', iconFile: 'books' },
      { id: 'classic-777', labelKey: 'casino.filter.classic777', iconSection: 'Themes', iconFile: 'classic' },
      { id: 'coins', labelKey: 'casino.filter.coins', iconSection: 'Themes', iconFile: 'coins' },
      { id: 'egypt', labelKey: 'casino.filter.egypt', iconSection: 'Themes', iconFile: 'egypt' },
      { id: 'fruits', labelKey: 'casino.filter.fruits', iconSection: 'Themes', iconFile: 'fruits' },
      { id: 'gods', labelKey: 'casino.filter.gods', iconSection: 'Themes', iconFile: 'gods' },
      { id: 'joker', labelKey: 'casino.filter.joker', iconSection: 'Themes', iconFile: 'joker' },
    ],
  },
];

export function mapCasinoFilterSections(t) {
  return CASINO_FILTER_SECTIONS.map((section) => ({
    id: section.id,
    label: t(section.labelKey),
    items: section.items.map((item) => ({
      id: item.id,
      label: t(item.labelKey),
      icon: staticAsset(selectionIconPath(item.iconSection, item.iconFile)),
    })),
  }));
}

const EXTRA_FILTER_MATCHERS = {
  'bonus-game': (g) => /bonus/i.test(g.name),
  'buy-feature': (g) => /buy|feature/i.test(g.name),
  'expanding-symbols': (g) => /expand|wild/i.test(g.name),
  'free-spins': (g) => g.freespin || /free spin|fs/i.test(g.name),
  multiplier: (g) => /multiplier|x\d/i.test(g.name),
  respins: (g) => /respin/i.test(g.name),
  'symbols-collection': (g) => /collect|coin|hold/i.test(g.name),
  animals: (g) => /animal|wolf|tiger|bear|panda/i.test(g.name),
  books: (g) => /book/i.test(g.name),
  'classic-777': (g) => /classic|777|retro|hot/i.test(g.name),
  coins: (g) => /coin/i.test(g.name),
  egypt: (g) => /egypt|pharaoh|cleopatra|anubis/i.test(g.name),
  fruits: (g) => /fruit|cherry|berry|blast/i.test(g.name),
  gods: (g) => /god|olympus|zeus|hades/i.test(g.name),
  joker: (g) => /joker/i.test(g.name),
};

export const EMPTY_CASINO_FILTERS = {
  query: '',
  provider: null,
  providers: [],
  tags: [],
  freespinOnly: false,
  searchActive: false,
};

export const SIDE_PANEL_RECOMMENDED_COUNT = 12;
export const SIDE_PANEL_RESULTS_LIMIT = 24;

const SIDE_PRIORITY_PROVIDERS = ['pragmatic play', 'playson', 'belatra', 'amusnet', 'endorphina', 'hacksaw'];

export function getSidePanelProviders(games) {
  const counts = new Map();
  for (const g of games) {
    if (!g.provider) continue;
    counts.set(g.provider, (counts.get(g.provider) || 0) + 1);
  }
  return [...counts.entries()]
    .map(([name, gameCount]) => ({ name, gameCount }))
    .sort((a, b) => (b.gameCount || 0) - (a.gameCount || 0) || a.name.localeCompare(b.name));
}

export function getSideRecommendedGames(games, currentGameId, count = SIDE_PANEL_RECOMMENDED_COUNT) {
  const pool = games.filter((g) => String(g.id) !== String(currentGameId));
  const priority = [];
  const rest = [];
  for (const game of pool) {
    const provider = (game.provider || '').toLowerCase();
    if (SIDE_PRIORITY_PROVIDERS.some((key) => provider.includes(key))) priority.push(game);
    else rest.push(game);
  }
  return [...priority, ...rest].slice(0, count);
}

export function getSideFilteredGames(
  games,
  { currentGameId, provider, query, limit = SIDE_PANEL_RESULTS_LIMIT },
) {
  let list = games.filter((g) => String(g.id) !== String(currentGameId));
  if (provider) list = list.filter((g) => g.provider === provider);
  if (query?.trim()) {
    const q = query.trim().toLowerCase();
    list = list.filter(
      (g) => g.name.toLowerCase().includes(q) || g.provider?.toLowerCase().includes(q),
    );
  }
  return list.slice(0, limit);
}

export function providerSlug(name = '') {
  return String(name)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

const PROVIDER_LOGO_EXTS = ['.svg', '.webp', '.png', '.jpg'];

export function localProviderLogoCandidates(slug) {
  if (!slug) return [];
  return PROVIDER_LOGO_EXTS
    .map((ext) => `/uploads/provider-logos/${slug}${ext}`)
    .map(withAssetCacheVersion);
}

export function resolveProviderLogoUrl(vendor) {
  if (vendor.logoUrl?.startsWith('/uploads/') || vendor.logoUrl?.startsWith('/api/')) {
    return withAssetCacheVersion(vendor.logoUrl);
  }
  if (vendor.logoUrl?.startsWith('http')) {
    return vendor.logoUrl;
  }
  return null;
}

export function mergeProviderOptions(apiVendors = []) {
  return [...apiVendors]
    .map((vendor) => ({
      name: vendor.name,
      slug: vendor.slug || providerSlug(vendor.name),
      logoUrl: resolveProviderLogoUrl(vendor),
      badge: vendor.badge || null,
      gameCount: vendor.gameCount ?? 0,
      sortOrder: vendor.sortOrder ?? 1000,
    }))
    .sort((a, b) => {
      if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
      return (b.gameCount || 0) - (a.gameCount || 0) || a.name.localeCompare(b.name);
    });
}

export const CASINO_LOBBY_ROUTE = {
  slots: null,
  live: 198,
  poker: 312,
  tv: 48,
  fast: 284,
  virtual: 293,
};

export const CASINO_LOBBY_TAB_DEFAULTS = {
  slots: [
    'review', 'vip-egt', 'amusnet', 'pragmatic-play', 'top', 'all', 'tournaments', 'jackpot-cards', 'new', 'world-cup',
    'buy-bonus', 'free-spins', 'exclusive', 'jackpot', 'cascade',
    'megaways', 'collect', 'wild', 'double', 'megax', 'respin', 'retro', 'fruits', 'books',
  ],
  live: [
    'review', 'top', 'all', 'new',
    'vip-tables', 'game-shows', 'roulette', 'blackjack', 'baccarat', 'poker-live', 'sic-bo',
  ],
  poker: ['review', 'top', 'all', 'holdem', 'caribbean', 'video-poker'],
  tv: ['review', 'top', 'all', 'new'],
  fast: [
    'review', 'tournaments', 'new', 'crash', 'table-games',
    'mines', 'plinko', 'dice', 'scratch', 'other',
  ],
  virtual: [
    'review', 'other',
  ],
};

export function localizeCasinoTabs(t) {
  return CASINO_PAGE_TABS.map((item) => ({
    ...item,
    label: t(`casino.tab.${item.id}`),
  }));
}

function mergeCasinoTabFromCms(cmsRow, knownTab) {
  const id = cmsRow?.tabKey || knownTab?.id;
  if (!id) return null;

  const tab = knownTab
    ? { ...knownTab }
    : {
      id,
      routeId: id,
      label: id,
      icon: null,
      iconActive: null,
    };

  const cmsLabel = cmsRow?.label?.trim();
  if (cmsLabel) tab.label = cmsLabel;

  // Digitech category art is authoritative — do not let CMS override with broken/gr8 mismatches.
  const forced = categoryIcons(id);
  if (forced.icon) {
    tab.icon = forced.icon;
    tab.iconActive = forced.iconActive || forced.icon;
  }

  return tab;
}

function cmsTabsForLobby(cmsTabs, lobbyKey, { homeOnly = false, reviewOnly = false } = {}) {
  if (!Array.isArray(cmsTabs)) return [];
  return cmsTabs
    .filter((row) => {
      if ((row.lobbyKey || 'slots') !== lobbyKey) return false;
      if (homeOnly && row.showOnHome === false) return false;
      if (reviewOnly && row.showInReview === false) return false;
      return true;
    })
    .slice()
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
}

function buildCasinoTabsFromCms(t, cmsTabs, lobbyKey, { homeOnly = false, reviewOnly = false, excludeIds = [] } = {}) {
  const allTabs = localizeCasinoTabs(t);
  const byKey = new Map(allTabs.map((tab) => [tab.id, tab]));
  const excluded = new Set(excludeIds);
  const cmsRows = cmsTabsForLobby(cmsTabs, lobbyKey, { homeOnly, reviewOnly });

  const rawIds = cmsRows.length
    ? cmsRows.map((row) => row.tabKey).filter((id) => !excluded.has(id))
    : (CASINO_LOBBY_TAB_DEFAULTS[lobbyKey] || CASINO_LOBBY_TAB_DEFAULTS.slots).filter((id) => !excluded.has(id));

  const seen = new Set();
  const tabIds = [];
  for (const id of rawIds) {
    if (!id || seen.has(id)) continue;
    seen.add(id);
    tabIds.push(id);
  }

  return tabIds
    .map((id) => {
      const cmsRow = cmsRows.find((row) => row.tabKey === id);
      return mergeCasinoTabFromCms(cmsRow, byKey.get(id));
    })
    .filter(Boolean);
}

export function casinoPageTabsFromCms(t, cmsTabs, lobbyKey = 'slots') {
  return buildCasinoTabsFromCms(t, cmsTabs, lobbyKey);
}

export function casinoTabsForLobby(t, cmsTabs, lobbyKey = 'slots') {
  return buildCasinoTabsFromCms(t, cmsTabs, lobbyKey, { homeOnly: true });
}

export function casinoRouteForLobby(lobbyKey) {
  return {
    casinoTabId: '-1',
    casinoLobbyId: CASINO_LOBBY_ROUTE[lobbyKey] ?? null,
  };
}

export function localizeCasinoLobbies(t) {
  return CASINO_LOBBIES.map((item) => ({
    ...item,
    label: t(`casino.lobby.${item.id}`),
  }));
}

export function collectCasinoProviders(games) {
  return [...new Set(games.map((g) => g.provider).filter(Boolean))].sort((a, b) => a.localeCompare(b));
}

export function applyCasinoFilters(games, filters = EMPTY_CASINO_FILTERS) {
  if (!games.length) return games;
  let out = games;
  const q = filters.query?.trim().toLowerCase();
  if (q) {
    out = out.filter(
      (g) => g.name.toLowerCase().includes(q) || g.provider?.toLowerCase().includes(q),
    );
  }
  if (filters.provider) {
    out = out.filter((g) => g.provider === filters.provider);
  }
  if (filters.freespinOnly) {
    out = out.filter((g) => g.freespin);
  }
  if (filters.tags?.length) {
    out = out.filter((g) => filters.tags.some((tag) => EXTRA_FILTER_MATCHERS[tag]?.(g)));
  }
  return out;
}

export const CASINO_REVIEW_SECTION_TABS = CASINO_PAGE_TABS.filter(
  (tab) => !['review', 'favourites', 'recommended', 'all'].includes(tab.id),
);

export function reviewSectionTabsFromCms(t, cmsTabs, lobbyKey = 'slots') {
  return buildCasinoTabsFromCms(t, cmsTabs, lobbyKey, {
    reviewOnly: true,
    excludeIds: ['review', 'favourites', 'recommended', 'all'],
  });
}

export function gamesForSection(allGames, tabId, count = 6) {
  const filtered = sortCasinoGames(filterCasinoGames(allGames, tabId));
  return filtered.slice(0, count);
}

export function countSectionGames(allGames, tabId) {
  return filterCasinoGames(allGames, tabId).length;
}

export function gameLuckyId(game) {
  if (game?.id != null) return String(game.id);
  const s = `${game?.name || ''}|${game?.provider || ''}`;
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return String(Math.abs(h) % 900000 + 10000);
}

export function pickLuckyGame(games) {
  if (!games?.length) return null;
  return games[Math.floor(Math.random() * games.length)];
}
